<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-checkbox v-model="model.fornecimento.escovaDental">
                Escova Dental
            </rkm-form-checkbox>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-checkbox v-model="model.fornecimento.cremeDental">
                Creme Dental
            </rkm-form-checkbox>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-checkbox v-model="model.fornecimento.fioDental">
                Fio Dental
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    props: {
        model: {type: Object, required: true},
    },
}
</script>
